import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
/**
 * Dashboard Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let DashBoard = /** @class */ (() => {
    let DashBoard = class DashBoard extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.title = "Dashboard";
            this.items = [
                {
                    text: "Dashboard",
                },
            ];
            this.statData = [
                {
                    icon: "bx bx-copy-alt",
                    title: "Orders",
                    value: "1,235",
                },
                {
                    icon: "bx bx-archive-in",
                    title: "Revenue",
                    value: "$35, 723",
                },
                {
                    icon: "bx bx-purchase-tag-alt",
                    title: "Average Price",
                    value: "$16.2",
                },
            ];
            this.transactions = [
                {
                    id: "#SK2540",
                    name: "Neal Matthews",
                    date: "07 Oct, 2019",
                    total: "$400",
                    status: "Paid",
                    payment: ["fa-cc-mastercard", "Mastercard"],
                    index: 1,
                },
                {
                    id: "#SK2541",
                    name: "Jamal Burnett",
                    date: "07 Oct, 2019",
                    total: "$380",
                    status: "Chargeback",
                    payment: ["fa-cc-visa", "Visa"],
                    index: 2,
                },
                {
                    id: "#SK2542",
                    name: "Juan Mitchell",
                    date: "06 Oct, 2019",
                    total: "$384",
                    status: "Paid",
                    payment: ["fab fa-cc-paypal", "Paypal"],
                    index: 3,
                },
                {
                    id: "#SK2543",
                    name: "Barry Dick",
                    date: "05 Oct, 2019",
                    total: "$412",
                    status: "Paid",
                    payment: ["fa-cc-mastercard", "Mastercard"],
                    index: 4,
                },
                {
                    id: "#SK2544",
                    name: "Ronald Taylor",
                    date: "04 Oct, 2019",
                    total: "$404",
                    status: "Refund",
                    payment: ["fa-cc-visa", "Visa"],
                    index: 5,
                },
                {
                    id: "#SK2545",
                    name: "Jacob Hunter",
                    date: "04 Oct, 2019",
                    total: "$392",
                    status: "Paid",
                    payment: ["fab fa-cc-paypal", "Paypal"],
                    index: 6,
                },
            ];
            this.showModal = false;
            this.isLoading = false;
            this.fullPage = true;
            this.canCancel = false;
            this.useSlot = false;
            this.loader = "spinner";
            this.color = "#007bff";
            this.bgColor = "#ffffff";
            this.height = 128;
            this.width = 128;
            this.timeout = 3000; // ms
            this.fetchingStats = true;
            this.earningStatus = true;
        }
        metaInfo() {
            return {
                meta: [
                    {
                        name: "SystemOne",
                        content: "SystemOne description",
                    },
                    { name: "keywords", content: "product acceleration platform, " },
                ],
                title: "SystemOne - DashBoard",
            };
        }
        mounted() {
            setTimeout(() => {
                this.showModal = true;
            }, 1500);
        }
        // public selectFeature(feature: FeatureModel): void {
        // 	SettingModule.GetFeatureRights(feature.id).then((response) => {
        // 		this.$router.push({ name: feature.route });
        // 	});
        // }
        // // COMPUTED
        // get features(): FeatureModel[] {
        // 	return FeatureModule.features;
        // }
        // // LIFECYCLE
        created() { }
    };
    DashBoard = __decorate([
        Component({
            name: "DashBoard",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], DashBoard);
    return DashBoard;
})();
export default DashBoard;
